/**
 * TORC — Scroll reveal & micro-interactions
 * Progressive enhancement: content is fully visible without JS.
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    document.documentElement.classList.add('torc-reveal-ready');
    return;
  }

  var REVEAL_SELECTOR = [
    '.torc-trust-strip__eyebrow',
    '.torc-press-logos',
    '.torc-reviews__header',
    '.torc-review-card',
    '.torc-testimonials__header',
    '.torc-testimonial-video',
    '.torc-comparison__header',
    '.torc-comparison__card',
    '.torc-product__header',
    '.torc-product__layout',
    '.torc-how-it-works__header',
    '.torc-how-it-works__image',
    '.torc-how-it-works__step',
    '.torc-benefits__header',
    '.torc-benefits__card',
    '.torc-affiliate__inner',
    '.torc-faq__header',
    '.torc-faq__item',
    '.torc-cta-banner__inner'
  ].join(', ');

  var STAGGER_PARENTS = [
    '.torc-reviews__track',
    '.torc-testimonials__grid',
    '.torc-comparison__grid',
    '.torc-how-it-works__steps',
    '.torc-benefits__grid',
    '.torc-faq__accordion'
  ].join(', ');

  function assignStagger(root) {
    var parents = root.querySelectorAll(STAGGER_PARENTS);
    parents.forEach(function (parent) {
      var children = parent.querySelectorAll(':scope > [data-torc-reveal]');
      children.forEach(function (child, i) {
        child.style.setProperty('--reveal-delay', Math.min(i * 70, 420) + 'ms');
      });
    });
  }

  function init() {
    var elements = document.querySelectorAll(REVEAL_SELECTOR);
    if (!elements.length) {
      document.documentElement.classList.add('torc-reveal-ready');
      return;
    }

    elements.forEach(function (el) {
      el.setAttribute('data-torc-reveal', '');
    });
    assignStagger(document);

    document.documentElement.classList.add('torc-reveal-ready');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    // Hero content: gentle staggered entrance on load
    var heroChildren = document.querySelectorAll('.hero__content-wrapper > *');
    heroChildren.forEach(function (child, i) {
      child.setAttribute('data-torc-hero', '');
      child.style.setProperty('--reveal-delay', i * 110 + 'ms');
    });

    requestAnimationFrame(function () {
      elements.forEach(function (el) {
        observer.observe(el);
      });
      document.documentElement.classList.add('torc-hero-in');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
